import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { AuthService } from './core/services/auth-security/auth.service';
import { LinkValidationResponse } from './shared/entities/LinkValidationResponse';
import { UserCredentialsFromApnLink } from './shared/entities/UserCredentialsFromApnLink';
import { DataService } from './core/services/data/data.service';
import { CookieUtils } from './shared/helpers/profiles/utility/cookie';
import { AppGeneralStateService } from './app-general-state.service';
import { LotList } from './shared/entities/LotList';
import { LotService } from './core/services/data/lot.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { takeUntil } from 'rxjs';
import { IAuthenticatedUserStartupData } from './shared/interfaces';
import { bootstrapApplication } from '@angular/platform-browser';
import { IParcsGetLotConfigurationResponse } from './shared/code/interfaces/parcs-interfaces';
import { ParcsDataService } from './core/services/data/parcs-data.service';
import { devLaunchAuth } from 'src/app/launch-auth';

@Component({
  selector: 'app-root',
  templateUrl: './launch.component.html',
})
export class LaunchComponent implements OnInit {
  title = 'lanai-routing';
  appId: string = '';
  linkId: string = '';
  validLinkId: boolean = false;
  currentUserId: string = '';
  userCredentials: UserCredentialsFromApnLink;
  LotListByUserName: LotList[] = [];
  defaultLotNumber: string = '';
  userStartupSequenceData: IAuthenticatedUserStartupData;
  lotParcsConfiguration: IParcsGetLotConfigurationResponse = {} as IParcsGetLotConfigurationResponse;

  //SERVICE
  _destroyRef = inject(DestroyRef);
  _router = inject(Router);
  _route = inject(ActivatedRoute);
  _authService = inject(AuthService);
  _dataService = inject(DataService);
  _appGeneralState = inject(AppGeneralStateService);
  _lotService = inject(LotService);
  _parcsDataService = inject(ParcsDataService);
  private _destroyRefService = inject(DestroyRef);

  ngOnInit(): void {
    this.appId = this._route.snapshot.params['app'];
    this.linkId = this._route.snapshot.params['key'];

    // 20240903 :: Ken Moss
    // Moved setting environment to appGeneralState on startup,
    // instead of getting from environment.ts each time.
    const aceParkUrl = environment.AceParkUrl;

    if (aceParkUrl == 'www.acepark.net') {
      this._appGeneralState.isEnvironmentDev = false;
    } else this._appGeneralState.isEnvironmentDev = true;

    // this.getApnLaunchLink();
    this.isValidLinkId(this.linkId);
  }

  isValidLinkId(linkId: string): boolean {
    let isLinkValid: boolean = false;

    //Sets Cookie Auth Ticket Session Duration
    // 20250131 :: Marked for deletion
    // this._dataService.getLanaiInitSettings();

    //Todo: Notes - Ken Moss
    //There are too many services and this should be refactored - AppGeneralState should be primary, don't need the _datastoreService and evaluate the _authService

    if (devLaunchAuth.enabled && devLaunchAuth.userId !== '') {
      // DEV Local workstation path
      this.currentUserId = devLaunchAuth.userId;
      this._appGeneralState.validatedUserId = this.currentUserId;
      this._appGeneralState.userId = this.currentUserId;
      this._appGeneralState.isAuthenticated = true;
      //this.getDevUserCredentialsByUserId(this.currentUserId);
      this.getAuthenticatedUserStartupData(this.currentUserId);
    } else {
      this.getUserIdFromApnLinkId(this.linkId);
    }

    return isLinkValid;
  }

  onNavigateToStartupModule(): void {
    if (this.appId === this._appGeneralState.getQuickSearchRoutingId()) {
      this._router.navigateByUrl('/quicksearch');
    }
    if (this.appId === this._appGeneralState.getProfileRoutingId()) this._router.navigateByUrl('/parkerv2');
    if (this.appId === this._appGeneralState.getUtilityRoutingId()) this._router.navigateByUrl('/utilities');
    if (this.appId === this._appGeneralState.getAdminRoutingId()) this._router.navigateByUrl('/adminhome');
    if (this.appId === this._appGeneralState.getCompanyRoutingId()) {
      this._router.navigateByUrl('/companylist');
    }
    if (this.appId === this._appGeneralState.getHomeRoutingId()) {
      this._router.navigateByUrl('/home');
    }
  }

  getAuthenticatedUserStartupData(userId: string): void {
    let startupData: IAuthenticatedUserStartupData;

    this._dataService
      .getAuthenticatedUserStartupDate(userId)
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe({
        next: (resp) => {
          this.userStartupSequenceData = resp;
          startupData = resp;
        },
        error: (err: any) => {},
        complete: () => {
          this.setStartupData(startupData);
        },
      });
  }

  setStartupData(bootSequenceData: IAuthenticatedUserStartupData): void {
    //Set Headers
    this.setCookie('lni', bootSequenceData.spaceArKey, 8);
    this.setCookie('space', bootSequenceData.spacePortalApiKey, 8);

    this._appGeneralState.isUserAdmin = bootSequenceData.isUserAdmin;
    this._appGeneralState.isSuperUser = bootSequenceData.isUserAdminSuperUser;
    this._appGeneralState.userName = bootSequenceData.userName;
    this._appGeneralState.userId = bootSequenceData.userId;

    this._appGeneralState.currentUserEmailAddress = bootSequenceData.emailAddress
      ? bootSequenceData.emailAddress
      : undefined;

    this.LotListByUserName = bootSequenceData.userLotList;
    this._appGeneralState.UsersLotList = bootSequenceData.userLotList;

    this.defaultLotNumber = bootSequenceData.mostRecentLotNumber;

    this._appGeneralState.getParcsLotConfigurationData(this.defaultLotNumber);

    if (this.defaultLotNumber === '') {
      this.defaultLotNumber = '-1';
      this._appGeneralState.currentLotNumber = '';
      this._appGeneralState.currentLotName = 'No Lot Selected';
    } else {
      this._appGeneralState.currentLotNumber = this.defaultLotNumber;
      this._appGeneralState.currentLotName = this.LotListByUserName.find(
        (arr) => arr.lotId == this.defaultLotNumber,
      ).lotName;
    }
    this.getParcsLotConfigurationData(this.defaultLotNumber);
  }

  getParcsLotConfigurationData(lotNumber: string) {
    this._parcsDataService
      .getParcsLotConfigurationByLotNumber(lotNumber)
      .pipe(takeUntilDestroyed(this._destroyRefService))
      .subscribe({
        next: (res) => {
          this.lotParcsConfiguration = res;

          if (this.lotParcsConfiguration.lotNumber == lotNumber) {
            this._appGeneralState.currentLotHasParcs = true;
          } else this._appGeneralState.currentLotHasParcs = false;
        },
        error: (err: any) => {
          this._appGeneralState.currentLotHasParcs = false; // no configuration found,
          this.onNavigateToStartupModule();
        },
        complete: () => {
          this.onNavigateToStartupModule();
        },
      });
  }

  getUserIdFromApnLinkId(linkId: string): void {
    let linkResponse: LinkValidationResponse;

    this._authService
      .validateApnLink(linkId)
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe({
        next: (res) => {
          linkResponse = res;
        },
        error: (err: any) => {},
        complete: () => {
          if (
            (linkResponse.userId !== '00000000-0000-0000-0000-000000000000' &&
              linkResponse.userId !== null &&
              linkResponse) ||
            undefined
          ) {
            this.validLinkId = true;
            this._appGeneralState.isAuthenticated = true;
            this.getAuthenticatedUserStartupData(linkResponse.userId);
          } else {
            this.validLinkId = false;
            this._appGeneralState.isAuthenticated = false;
            this._appGeneralState.setValidatedUserId('');
            this._router.navigateByUrl('/badroute');
          }
        },
      });
  }

  private setCookie(name: string, value: string, hours: number) {
    var expires = '';

    if (hours) {
      var date = new Date();
      date.setTime(date.getTime() + hours * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }

    document.cookie = name + '=' + (value || '') + expires + '; path=/';
  }
}
